import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import urljoin from 'url-join';
// eslint-disable-next-line max-len
import { type MobilityApplicationEntrypointContextDataFragment } from '../../../../../api/fragments/MobilityApplicationEntrypointContextData';
import BasicProLayoutContainer from '../../../../../layouts/BasicProLayout/BasicProLayoutContainer';
import { useThemeComponents } from '../../../../../themes';
import Stepper, { AvailableSteps as GiftCodeSteps, MobilityPageKind } from '../../Components/Stepper';
import { type GiftVoucherState } from '../reducer';
import ThankYouContent from './ThankYouContent';

export type ThankYouPageProps = {
    state: GiftVoucherState;
    endpoint: MobilityApplicationEntrypointContextDataFragment;
};

const ThankYouPage = ({ state, endpoint }: ThankYouPageProps) => {
    const { t } = useTranslation(['giftVoucherThankYou']);
    const { StandardLayout } = useThemeComponents();
    const navigate = useNavigate();
    const thankYouContent = useMemo(() => {
        const title = t('giftVoucherThankYou:titles.default');
        const subTitle = t('giftVoucherThankYou:subTitles.purchasedSuccessfully');
        const description = t('giftVoucherThankYou:descriptions.purchasedSuccessfully');
        const reference = t('giftVoucherThankYou:reference', { reference: state?.giftVoucher?.giftCode });

        return { title, subTitle, description, reference, state };
    }, [state, t]);

    useEffect(() => {
        navigate(urljoin(endpoint.pathname, 'giftCode/thankyou'), { replace: true });
    }, [endpoint.pathname, navigate]);

    return (
        <StandardLayout title={thankYouContent.title}>
            <BasicProLayoutContainer>
                <Stepper currentPage={MobilityPageKind.Gift} currentStep={GiftCodeSteps.Confirmation} />
                <ThankYouContent {...thankYouContent} />
            </BasicProLayoutContainer>
        </StandardLayout>
    );
};

export default ThankYouPage;
